import type { ProjectItem } from "../types";

type Props = { proj: ProjectItem };

const ProjectCard = ({ proj }: Props) => (
  <article className="proj-card">
    <a className="proj-shot" href={proj.link} target="_blank" rel="noreferrer">
      <img
        src={proj.snapshot}
        alt={proj.name}
        loading="lazy"
        onError={(e) => {
          (e.currentTarget.closest(".proj-shot") as HTMLElement)?.classList.add("no-img");
        }}
      />
      <span className="proj-shot-fallback" aria-hidden="true">{proj.name}</span>
      <span className="proj-visit">Visit ↗</span>
    </a>
    <div className="proj-body">
      <div className="proj-head">
        <h3 className="proj-name">{proj.name}</h3>
        <span className="proj-tagline">{proj.tagline}</span>
      </div>
      <p className="proj-desc">{proj.description}</p>
      <div className="proj-foot">
        <ul className="proj-tech">
          {proj.tech.map((t) => <li key={t}>{t}</li>)}
        </ul>
        <a className="proj-code" href={proj.source} target="_blank" rel="noreferrer">Code →</a>
      </div>
    </div>
  </article>
);

export default ProjectCard;
